import {memo} from 'react';
import {styled} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {bold, subheadH2, paragraph16, bgMain, textPrimary, focusNormal, subheadH3} from 'r/Design';
import {SANR_DISCORD} from 'r/constants/links';
import SmartLink from '../SmartLink';
import oopsImage from './oops.png';


const Wr = styled.div`
  background: ${bgMain};
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (max-width: 767px) {
    padding: 0 8px;
  }
`;

const Image = styled.img`
  width: 316px;
  height: 199px;
  @media (max-width: 767px) {
    width: 262px;
    height: 166px;
  }
`;

const Header = styled.div`
  ${subheadH2}
  line-height: 48px;
  ${bold}
  color: ${textPrimary};
  @media (max-width: 767px) {
    max-width: 262px;
    ${subheadH3}
  }
`;

const Description = styled.div`
  margin-top: 16px;
  ${paragraph16}
  color: ${textPrimary};
  @media (max-width: 767px) {
    max-width: 262px;
  }
`;

const Link = styled(SmartLink)`
  text-decoration: underline;
  color: ${focusNormal};
  display: inline;
`;

const ButtonWr = styled.div`
  margin-top: 32px;
`;


export default memo(UiError);

UiError.propTypes = forbidExtraProps({});

function UiError() {

  return (
    (
      <Wr>
        <Image src={oopsImage}/>
        <Header>Oops!</Header>
        <Header>Seems like something went wrong</Header>
        <Description>
          Let us know about the issue in our <Link to={SANR_DISCORD}>Discord</Link>.<br/>We will look into it ASAP.
        </Description>
        <ButtonWr>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-amber-50 rounded-xl p-2 cursor-pointer"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </ButtonWr>
      </Wr>
    )
  );
}
